import { Text } from '@griply/assets';
import { isPlainTextUnchangedFromHtml, plainTextToHtml } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RichText } from 'shared/components/ui/rich-text';
import { UrlParserTextArea } from 'shared/components/ui/url-parser';

import * as Styled from '../event-form.style';
import { EventRow } from '../event-row';

export type EventDescriptionRowProps = {
  value: string;
  // the provider's original markup; `value` is only its plain-text projection, so inline
  // marks (bold, italic) live here and nowhere else
  html?: string | null;
  disabled?: boolean;
  isLoading?: boolean;
  onChange?: (description: string) => void;
};

export const EventDescriptionRow: React.FC<EventDescriptionRowProps> = ({
  value,
  html,
  disabled,
  isLoading,
  onChange,
}) => {
  const { t } = useTranslation();

  const isReadOnly = !!disabled || !onChange;

  // Until the user edits, the original markup is still an accurate rendering of the text and
  // carries marks the projection cannot; after an edit only their own text is truthful.
  const isUntouched = !!html && isPlainTextUnchangedFromHtml(value, html);
  const readView = (
    <RichText value={isUntouched ? html : plainTextToHtml(value)} />
  );

  return (
    <EventRow icon={Text} isLoading={isLoading} alignTop>
      <Styled.DescriptionField>
        {isReadOnly ? (
          readView
        ) : (
          <UrlParserTextArea
            value={value}
            onChange={onChange}
            readView={readView}
            placeholder={t('forms.event.fields.description.placeholder')}
            variant="body2"
            respectNewLines
          />
        )}
      </Styled.DescriptionField>
    </EventRow>
  );
};
